import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { APP_CONFIG } from '../../utils/app.config';

@Component({
    selector: 'isophi-language-picker',
    templateUrl: './language-picker.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LanguagePickerComponent {
  get availableLangs(): string[] {
    return this.i18n.getAvailableLangs() as string[];
  }
  public readonly i18n = inject(TranslocoService);
  public readonly appConfig = inject(APP_CONFIG);
}
